module.exports = __webpack_public_path__ + "img/foto-s-zanatiy-2.5ceeab81.png";